export enum ChampionshipFormStep {
  GENERAL,
  LOCATION,
  CATEGORIES,
  COUNTRIES,
}
